import React from 'react'
import { useForm, Form, Field } from '../../../form'
import classNames from 'classnames'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import LinearProgress from '@material-ui/core/LinearProgress'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../../utils/snackbar.utils'
import { useHistory } from 'react-router-dom'
import { Panel } from 'react-bootstrap'
import { faqFunction } from '../../../utils/website.utils'
import { Translation } from 'react-i18next'
import { registerValidate } from '../../../containers/employer/validate'
import CompanySearchField from '../../common/companySearchField'

/**
 * The register view
 *
 * @author  Pragya Gupta
 */

class Register extends React.Component {
  componentDidMount() {
    faqFunction()
  }

  render() {
    return <RegisterComponent {...this.props} />
  }
}

const styles = (theme) => ({
  button: {
    width: '100%'
  },
  textField: {
    marginTop: theme.spacing(4),
    minWidth: 100,
    border: '1px solid gray'
  },
  resize: {
    fontSize: '14px'
  },
  progress: {
    flexGrow: 1
  },
  checkbox: {
    marginTop: theme.spacing(3),
    fontSize: '15px',
    fontWeight: '500',
    color: '#808080'
  }
})

const defaultValues = {
  company_name: '',
  y_tunnus: '',
  contact_name: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  agree_to_terms: false
}

const RegisterComponent = ({
  registerFormSubmit,
  showSnackbar,
  showSpinner,
  closeRegisterSnackbar,
  showFailSnackbar,
  errorMessage,
  classes
}) => {
  const history = useHistory()

  function onSubmit(values) {
    registerFormSubmit(values)
  }

  const form = useForm({
    name: 'register',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: registerValidate
  })

  const { control } = form

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Form {...form}>
              <div className="form-register-container">
                <div className="panel panel-default panel-register">
                  <div className="panel-heading">
                    <h3 className="panel-title">{t('employer.register.h3')}</h3>
                  </div>
                  <div style={{ marginBottom: '30px' }} className="panel-body">
                    <div>
                      <CompanySearchField
                        form="register"
                        name="company_name"
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="y_tunnus"
                        inputType="textfield"
                        label={t('employer.register.bID')}
                        type="text"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="contact_name"
                        inputType="textfield"
                        label={t('employer.register.contact_name')}
                        type="text"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="email"
                        inputType="textfield"
                        label={t('employer.register.email')}
                        type="text"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="password"
                        inputType="textfield"
                        label={t('employer.register.psw')}
                        type="password"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="passwordConfirmation"
                        inputType="textfield"
                        label={t('employer.register.psw2')}
                        type="password"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        control={control}
                      />
                    </div>
                    <div>
                      <Field
                        name="agree_to_terms"
                        label={t('employer.register.agree')}
                        inputType="checkbox"
                        className={classes.checkbox}
                        control={control}
                      />
                    </div>
                    <div className="form-register-btn">
                      <Button
                        variant="contained"
                        className={classes.button}
                        type="submit"
                      >
                        {t('employer.register.button')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={showSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                history.push('/dashboard/employerLogin')
                closeRegisterSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  history.push('/dashboard/employerLogin')
                  closeRegisterSnackbar()
                }}
                variant="success"
                message={t('employer.register.msg')}
              />
            </Snackbar>
            {errorMessage === 'UserExist' ? (
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={showFailSnackbar}
                autoHideDuration={4000}
                onClose={() => {
                  closeRegisterSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  onClose={() => {
                    closeRegisterSnackbar()
                  }}
                  variant="error"
                  message={t('employer.register.userExist')}
                />
              </Snackbar>
            ) : (
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center'
                }}
                open={showFailSnackbar}
                autoHideDuration={4000}
                onClose={() => {
                  closeRegisterSnackbar()
                }}
              >
                <MySnackbarContentWrapper
                  onClose={() => {
                    closeRegisterSnackbar()
                  }}
                  variant="error"
                  message={t('employer.register.msg2')}
                />
              </Snackbar>
            )}

            <div className="form-login-terms">
              <Panel className="faqpanels">
                <div className="collapsepanel">
                  <div className="title">{t('employer.terms.use')}</div>
                  <div className="terms">
                    <p>{t('employer.terms.p1')}</p>
                    <p>{t('employer.terms.p2')}</p>
                    <p>{t('employer.terms.p3')}</p>
                    <p>{t('employer.terms.p4')}</p>
                    <p>{t('employer.terms.p5')}</p>
                    <p>{t('employer.terms.p6')}</p>
                    <p>{t('employer.terms.p7a')}</p>
                    <p>{t('employer.terms.p7b')}</p>
                    <p>{t('employer.terms.p8')}</p>
                    <p>{t('employer.terms.p9a')}</p>
                    <p>{t('employer.terms.p9b')}</p>
                    <p>{t('employer.terms.p9c')}</p>
                    <p>{t('employer.terms.p10a')}</p>
                    <p>{t('employer.terms.p10b')}</p>
                    <p>{t('employer.terms.p11')}</p>
                    <p>
                      {t('employer.terms.p12')}
                      <br />
                      {t('employer.terms.p12a')}
                    </p>
                    <p>{t('employer.terms.p12b')}</p>
                    <p>{t('employer.terms.p12c')}</p>
                    <p>{t('employer.terms.p12d')}</p>
                  </div>
                </div>
              </Panel>
            </div>
            <Dialog
              open={showSpinner}
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText
                  id="alert-dialog-description"
                  style={{ fontSize: '15px', margin: '20px' }}
                >
                  {t('employer.register.regi')}
                </DialogContentText>
              </DialogContent>
              <div className={classes.progress}>
                <LinearProgress />
              </div>
            </Dialog>
          </div>
        )
      }}
    </Translation>
  )
}

export default withStyles(styles)(Register)
